import { setGetPaymentsMethodByIdAction } from '../action';
import { getPaymentsMethodById } from '../api/getPaymentsMethodById';

export const setGetPaymentsMethodById = (params, callback) => {
    return async (dispatch, getState) => {
        try {
            const {data} = await getPaymentsMethodById(params);
            dispatch(setGetPaymentsMethodByIdAction(data.data))

            if (callback) {
                callback();
            }
        } catch(error) {
            if (error?.response?.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}